<template>
  <div v-if="permission && permission.version === '5'" class="job-board-page">
    <b-container fluid class="page_content">
      <div class="pg_toolbar job-board-toolbar">
        <div class="toolbar-left data-row">
          <div class="toolbar-select-all" v-if="results.length > 0">
            <div class="facet_list">
              <div class="checkbox ace_sec_txt">
                <span class="form-checkbox">
                  <input type="checkbox" :disabled="permission.systemPermission.readOnly" v-model="selectAllObjects" @click="actionForSelectAllObjects" :aria-label="$t('all')">
                  <i class="form-icon"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="toolbar-title ace_sec_txt">
            <span class="ic2_job-briefcase"></span>
            <h1 class="head_txt module_type_name ace_sec_hd">
              {{ $t('jobs') }} [{{total}}]
            </h1>
          </div>
          <!-- Job Type Filter -->
          <div class="explore_filter">
            <b-button @click.stop="toggleJobDropDown" id="jobDropDown" class="form-field job-type-filter ace_sec" tabindex="0">
              <label>
                <span class="txt_sh">{{ $t('jobType') }}</span>
                <span class="icon-dropdown1"></span>
              </label>
            </b-button>
            <div id="jobDropDownPopup" class="dropdown_popover explore_filter_container"></div>
            <b-popover target="jobDropDown" :show.sync="showJobTypeDropDown" container="jobDropDownPopup" triggers="blur">
              <div class="popup_content">
                <div class="field-row" v-for="(type, index) in jobType" :key="'jobType-' + type.value">
                  <input type="checkbox" :id="'manage-jobType-filter-' + index" :value="type.value" v-model="jobTypeSelected" @click.stop @input.stop>
                  <label :for="'manage-jobType-filter-' + index">{{ type.text }}</label>
                </div>
              </div>
              <b-btn @click="toggleJobDropDown" class="range-button">{{ $t('ok') }}</b-btn>
            </b-popover>
          </div>
          <!-- Salary Range Filter -->
          <div class="explore_filter">
            <b-button @click.stop="toggleSalaryRangeDropDown" id="manageSalaryRangeDropDown" class="form-field salary-filter ace_sec" tabindex="0">
              <label>
                <span class="txt_sh">{{ $t('salaryRange') }}</span>
                <span class="icon-dropdown1"></span>
              </label>
            </b-button>
            <div id="manageSalaryRangeDropDownPopup" class="dropdown_popover explore_filter_container"></div>
            <b-popover target="manageSalaryRangeDropDown" :show.sync="showSalaryRangeDropDown" container="manageSalaryRangeDropDownPopup" triggers="blur">
              <div class="popup_content">
                <div class="field-row" v-for="(range, index) in salaryRangeGroups" :key="'salary-' + range.label">
                  <input type="checkbox" :id="'manage-salary-filter-' + index" :value="range.label" v-model="salaryRangeSelected" @click.stop @input.stop>
                  <label :for="'manage-salary-filter-' + index">{{ range.label }}</label>
                </div>
              </div>
              <b-btn @click="toggleSalaryRangeDropDown" class="range-button">{{ $t('ok') }}</b-btn>
            </b-popover>
          </div>
        </div>
        <div class="toolbar-right">
          <div class="out-of-total-item ace_sec_txt">
            <div>{{numberOfSelectedItems}} {{ $t('outOf') }} {{total}} </div>
          </div>
          <div class="number-of-item ace_sec_txt">
            <b-dropdown id="ddown-buttons" :text="''+size" :options="sizeOptions" :aria-label="$t('numberOfItem')">
              <template v-for="(option, index) in sizeOptions">
                <b-dropdown-divider v-if="index > 0"></b-dropdown-divider>
                <b-dropdown-item @click="changeSize(option)">{{ option }} {{ $t('itemPerPage') }}</b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
          <div class="pagination btn_container pagination_sty3">
            <button type="button" class="btn btn_trans" :disabled="pageNumber <= 1" @click="prevPage" @keydown.enter="prevPage" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="current-page ace_sec_txt">{{pageNumber}}</span>
            <button type="button" class="btn btn_trans" :disabled="(from + size) >= total" @click="nextPage" @keydown.enter="nextPage" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
          <div class="search-box-container">
            <input type="text" class="input-search" :placeholder="$t('typeToNarrowResults')" v-on:keypress.enter="searchButtonClicked" v-model.trim="searchTerms" :aria-label="$t('typeToNarrowResults')">
            <button class="btn btn_srh" @click="searchButtonClicked" :aria-label="$t('goAria')">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
            <button id="sortByDropDown" type="button" @click="toggleSortByDropDown" class="sort-by ace_sec">
              <span class="ic2_sort2 sort-by-icon" aria-hidden="true"></span>
              <span class="txt_srt">{{ $t('sort') }}</span>
            </button>
            <div id="jobListSortPopup" class="sort_by_popover"></div>
          </div>
          <b-popover
            target="sortByDropDown"
            :show.sync='showSortByDropDown'
            container="jobListSortPopup"
            custom-class="sort_by_modal"
            triggers="blur">
            <div class='header-content-row'>
              <span class="title">{{ $t('sortBy') }}</span>
            </div>
            <template v-for="sort in sorts">
              <div class="field-row" :key="sort.name">
                <div class="form-check">
                  <input type="radio" class="form-check-input" :id="sort.name" v-model="selectedSortName" :value="sort.name">
                  <label class="form-check-label" :for="sort.name">{{ sort.labelKey ? $t(sort.labelKey) : sort.name }}</label>
                </div>
              </div>
            </template>
            <div class="btn_container" style="text-aling: right; padding: 12px;">
              <b-btn @click="sortOkClicked" class="modal_btn_confirm" style="color: #fff !important;">{{ $t('ok') }}</b-btn>
            </div>
          </b-popover>
          <template v-if="!(permission.systemPermission.readOnly || isStudentLogin)">
            <button
              class="btn ace_sec_txt"
              @click="createJobClicked"
              style="margin-left: 8px;"
              >
              {{ $t('create') }}
            </button>
            <button
              class="btn btn_ic ic_bin ace_sec_txt"
              :class="[(selectedUuids.length === 0) ? 'disable' : '']"
              @click="showDeleteConfirmBox"
              :aria-label="$t('deleteAria')"
              >
            </button>
          </template>
        </div>
      </div>

      <b-input-group class="job-board-filter-tags filter-tags-wrapper">
        <template v-for="(idxSelected, index) in (selectedFacets.jobTypeSelected || [])">
          <div class="search_tag filter-tag" :key="'jobType-' + index">
            <span class="title job-type-tag">{{ formatJobTypeLabel(idxSelected) }}</span>
            <span class="ic_btn ic_bin" :aria-label="$t('deleteAria')" tabindex="0" @click.stop="removeSelectedFacet('jobTypeSelected', index)">
            </span>
          </div>
        </template>
        <template v-for="(idxSelected, index) in salaryRangeSelected">
          <div class="search_tag filter-tag" :key="'salary-' + index">
            <span class="title salary-tag">{{idxSelected}}</span>
            <span class="ic_btn ic_bin" :aria-label="$t('deleteAria')" tabindex="0" @click.stop="removeSelectedFacet('salaryRangeSelected', index)">
            </span>
          </div>
        </template>
        <template v-for="(idxSelected, index) in tagSelected">
          <div class="search_tag filter-tag" :key="'job-tag-' + index">
            <span class="title job-applied-tag">{{idxSelected.name || idxSelected}}</span>
            <span class="ic_btn ic_bin" :aria-label="$t('deleteAria')" tabindex="0" @click.stop="removeSelectedFacet('tagSelected', index)">
            </span>
          </div>
        </template>
      </b-input-group>

      <b-row class="explore_entity_result">
        <div cols="12" class="datatable">
          <b-row class="search_result_container">
            <b-col cols="12">
              <b-list-group>
                    <template v-if="results.length === 0">
                      <div class="msg_no_result ace_sec_txt">
                        {{ $t('noResult') }}
                      </div>
                    </template>
                <template v-else>
                  <b-list-group-item class="flex-column align-items-start result_row" v-for="(result, index) in results" :key="result.uuid">
                    <div>
                      <div class="facet_list">
                        <div class="checkbox ace_sec_txt">
                          <span class="form-checkbox">
                            <input type="checkbox" :aria-labelledby="'entity_' + index" :value="result.uuid" :disabled="permission.systemPermission.readOnly" v-model="selectedUuids" @change="itemCheckboxToggle($event, result)">
                            <i class="form-icon"></i>
                          </span>
                        </div>
                      </div>
                      <div class="result_block">
                        <div class="d-flex w-100 job-header-row">
                          <a
                            href="#"
                            class="title ace_sec_txt job-count-link"
                            @click.prevent="redirectToResult(result)"
                            :id="'entity_' + index"> {{ result.title }} </a>
                          <div class="job-employer">
                            <div
                              class="employer-avatar"
                              :class="{ 'has-logo': employerLogo(result) }"
                              :style="employerLogo(result) ? null : { background: avatarColor(index) }">
                              <img
                                v-if="employerLogo(result)"
                                :src="employerLogo(result)"
                                :alt="result.employer || ''">
                              <span v-else>{{ employerInitials(result.employer) }}</span>
                            </div>
                            <a
                              href="#"
                              class="title ace_sec_txt job-count-link"
                              @click.prevent.stop="showEmployer(result)"> {{ result.employer }} </a>
                          </div>
                        </div>
                        <div class="result_block_row job-meta-row job-meta-align">
                          <div class="job-meta-item">
                            <div class="icon_container">
                              <span class="ic_salary"></span>
                            </div>
                            <div class="ace_sec_txt">
                              {{result.salaryRange}}
                            </div>
                          </div>
                          <div class="job-meta-item">
                            <div class="icon_container">
                              <span class="ic2_part-full-time-job"></span>
                            </div>
                            <div class="ace_sec_txt">
                              {{ formatJobTypeLabel(jobTypeLabel(result)) }}
                            </div>
                          </div>
                          <div class="job-meta-item">
                            <div class="icon_container">
                              <span class="icon-location"></span>
                            </div>
                            <div class="ace_sec_txt">
                              {{ jobLocation(result) }}
                            </div>
                          </div>
                        </div>
                        <div class="result_block_row job-meta-row job-meta-align">
                          <div class="job-meta-item">
                            <div class="icon_container">
                              <span class="ic2_calendar"></span>
                            </div>
                            <div class="ace_sec_txt">
                              {{ $t('postedOn') }} {{ millisToDate(result.postedDate || result.creationTime) }}
                            </div>
                          </div>
                          <div class="job-meta-item">
                            <div class="icon_container">
                              <span class="ic2_applyBy"></span>
                            </div>
                            <div class="ace_sec_txt">
                              {{ $t('applyBy') }} {{ millisToDate(result.applyBy) }}
                            </div>
                          </div>
                          <div class="job-meta-item job-tags-item">
                            <div class="icon_container">
                              <span class="ic22-tag2"></span>
                            </div>
                            <div class="details ace_sec_txt">
                            <template v-if="result && ((result.appliedTagMap && Object.values(result.appliedTagMap).some(t => t && t.length > 0)) || (result.careerCompetenciesList && result.careerCompetenciesList.length > 0))">
                              <div class="tags_container">
                                <div class="tags_cat">
                                  <div class="tag" v-for="item in visibleJobTags(result)" :key="item.key" :class="item.cssClass" :aria-label="item.name" tabindex="0" role="button" @click.stop="filterJobsByTag(item)" @keydown.enter.prevent="filterJobsByTag(item)">
                                    <span class="tag_name" :class="item.nameClass" :title="item.name">{{item.name}}</span>
                                    <span class="tag_lavel" v-if="item.level">{{item.level}}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="job-all-tags">
                                <div class="tags_cat" v-if="result.appliedTagMap" :id="'tagsRow_' + index">
                                  <template v-for="(values, key) in result.appliedTagMap">
                                    <div class="tag" v-for="tag in values" :key="tag.uuid || tag.name" :aria-label="tag.name" tabindex="0">
                                      <span class="tag_name instructional_tag" :title="tag.name">{{tag.name}}</span>
                                    </div>
                                  </template>
                                </div>
                                <div class="tags_cat" v-if="result.careerCompetenciesList && result.careerCompetenciesList.length > 0" :id="'specialTagsRow_' + index">
                                  <div class="tag" v-for="specialTag in result.careerCompetenciesList" :key="specialTag.uuid || specialTag.name" :class="specialTag.tagType" :aria-label="specialTag.name" tabindex="0">
                                    <span class="tag_name competency_tag" data-toggle="tooltip" data-placement="top" :title="specialTag.name">{{specialTag.name}}</span>
                                    <span class="tag_lavel" v-if="specialTag.fulfillLevels && specialTag.fulfillLevels.length > 0">
                                    {{specialTag.fulfillLevels[0]}}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <b-button class="btn ic_btn btn_ellipsis"
                                v-if="hasMoreJobTags(result)"
                                @click.stop="showTagsPopup(result)"
                                :aria-label="$t('showAllTags')"
                                :title="$t('showAllTags')"
                                v-b-tooltip.hover
                                tabindex="0">
                                <span class="module_icon ic9-iconMore-0005 ic_more"></span>
                              </b-button>
                            </template>
                            <template v-else>
                              <div class="no_tags">
                                <div class="empty_pattern ace_sec_txt">{{ $t('na') }}</div>
                              </div>
                            </template>
                            <b-button class="btn btn_ic ic24-pencil"
                              v-if="canApplyTag(result.ownerId, result)" v-on:click="showAddTagPopup(result, $event)"
                              :title="$t('editTags')"
                              :aria-label="$t('editTags')"
                              v-b-tooltip.hover
                              tabindex="0">
                            </b-button>
                          </div>
                          </div>
                        </div>

                        <div class="result_block_row job-meta-row job-meta-align">
                          <div class="job-meta-item">
                            <div class="icon_container">
                              <span class="ic22-eye" aria-hidden="true"></span>
                            </div>
                            <a
                              href="#"
                              class="ace_sec_txt job-count-link"
                              @click.prevent.stop="redirectToViewers(result)">
                              {{ result.viewCount || 0 }} {{ $t('views') }}
                            </a>
                          </div>
                          <div class="job-meta-item">
                            <div class="icon_container">
                              <span class="ic2_job-application" aria-hidden="true"></span>
                            </div>
                            <a
                              href="#"
                              class="ace_sec_txt job-count-link"
                              @click.prevent.stop="redirectToApplicants(result)">
                              {{ applicantCountMessage(result) }}
                            </a>
                          </div>
                        </div>

                        <div class="result_block_row job-meta-row description_row ace_sec_txt">
                          <div class="job-meta-item job-description-item">
                            <div class="icon_container">
                              <span class="icon-paragraph-left"></span>
                            </div>
                            <div class="title_new" v-if="plainDescription(result)">
                              <v-clamp class="title_txt" autoresize :max-lines="1">{{ plainDescription(result) }}</v-clamp>
                            </div>
                            <div v-else class="no-description">
                              No description added for this job
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="thumbnail ace_sec_txt">
                        <div class="thumbnail_default ico-job2" @click="redirectToResult(result)" :aria-label="$t('job')"></div>
                      </div>
                    </div>
                  </b-list-group-item>
                  <template>
                    <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
                  </template>
                </template>
              </b-list-group>
            </b-col>
          </b-row>
        </div>
        <div>
          <b-modal ref="tagsListPopup" :title="$t('tags')" class="modal__v22_2" size="lg" hide-header-close no-close-on-backdrop no-close-on-esc centered>

            <div slot="modal-header" class="row header-section w-100">
    					<div class="col-11 hd">
    						<div class="ic_container">
                  <span class="ic ic-tag"></span>
    						</div>
    						<div class="hd_txt">
    							<span>{{ $t('tags') }}</span>
    						</div>
    					</div>
    					<div class="col-1 btn_container pr-0 mt-0">
    						<button class="btn_close" :aria-label="$t('closeAria')" @click="closeTagsPopup">
    							 <span class="ic-close"></span>
    						</button>
    					</div>
    				</div>

            <div class="details">
              <div class="tags_container" id="tagsListContainer">
                <div class="tag" v-for="item in popupTags" :key="item.key" :class="item.cssClass" :aria-label="item.name" tabindex="0" role="button" @click.stop="onPopupTagClick(item)" @keydown.enter.prevent="onPopupTagClick(item)">
                  <span class="tag_name" :class="item.nameClass" :title="item.name">{{item.name}}</span>
                  <span class="tag_lavel" v-if="item.level">{{item.level}}</span>
                </div>
              </div>
            </div>

            <div slot="modal-footer" class="w-100">
              <div class="btn_container">
                <b-button type="button" class="btn" @click="closeTagsPopup">{{ $t('ok') }}</b-button>
              </div>
            </div>
          </b-modal>
        </div>

        <div>
          <b-modal ref="deleteConfirmModal" :title="$t('pleaseConfirm')" :header-bg-variant="'discover-content-delete-modal'" hide-header-close no-close-on-backdrop no-close-on-esc centered>
            <div style="text-align: center;">
              <h6>{{ $t('areYouSureYouWantToDelete') }}</h6>
              <h6>({{selectedObjects.length}}) {{ $t('jobs') }}</h6>
            </div>
            <div slot="modal-footer" class="w-100">
              <b-button @click="deleteItems" class="btn button-primary next float-right mr-2"> {{ $t('yes') }} </b-button>
              <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2"> {{ $t('no') }} </b-button>
            </div>
          </b-modal>
        </div>
        <div class="loading-spinner">
          <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
            <div class="text-center" style="color: #FFF; overflow: hidden;">
              <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
              <div class="mt-4" v-if="loadingMessage">
                <span>{{loadingMessage}}</span>
              </div>
            </div>
          </b-modal>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import AddTagPopup from '../../tagging/components/AddTagPopup'
  import { getSimpleLibraryFilter } from '../searchUtils.js'
  import '../../../assets/module/sass/discover/discover.scss'
  import { EntityUtil } from '../../../entityUtils'
  import VClamp from 'vue-clamp'

  export default {
    name: 'manageJobs',
    props: [],
    components: {
      AddTagPopup,
      VClamp
    },
    data: () => {
      return {
        folders: [],
        allFolders: [],
        foldersSelected: [],
        privateLibraryList: [],
        publicLibraryList: [],
        selectedUuids: [],
        selectedObjects: [],
        selectAllObjects: false,
        userId: '',
        libraryList: '',
        jobType: [],
        jobTypeSelected: [],
        salaryRangeSelected: [],
        tagSelected: [],
        popupTags: [],
        salaryRangeGroups: [
          { label: 'Below $25,000', minLt: 25000 },
          { label: '$25,000-$50,000', minGt: 25000, maxLt: 50000 },
          { label: '$50,000-$75,000', minGt: 50000, maxLt: 75000 },
          { label: '$75,000-$100,000', minGt: 75000, maxLt: 100000 },
          { label: '$100,000-$150,000', minGt: 100000, maxLt: 150000 },
          { label: 'Above $150,000', minGt: 150000 }
        ],
        indexList: 'job',
        facets: {},
        filter: {},
        source: ['title', 'uuid', 'name', 'description', 'type', 'employer', 'employerUuid','salaryRange', 'minSalary', 'maxSalary', 'contactInfo', 'jobTypes', 'creationTime', 'postedDate', 'applyBy', 'viewCount', 'applicantCount', 'lastUpdatedTime', 'thumbnail', 'thumbnailURI', 'thumbnailURIList', 'uri', '_score', 'appliedTagMap', 'aggregatedAppliedTags', 'fileType', 'originUuid', 'master', 'careerCompetenciesMap', 'careerCompetenciesList', 'ownerId', 'ownerName'],
        sizeOptions: [ 10, 50, 100 ],
        ignoreFolderWatch: false,
        ignoreJobWatch: false,
        ignoreSalaryWatch: false,
        ignoreTagWatch: false,
        isShowTagPopup: false,
        taggingEntityData: {},
        loadingMessage: null,
        showJobTypeDropDown : false,
        showSalaryRangeDropDown: false,
        showSortByDropDown: false,
        sorts: [
        {name: 'Relevance', clause: [{_score: {order: 'desc'}}]},
        {name: 'Title', labelKey: 'title', clause: [{'title.raw': {order: 'asc'}}]},
        {name: 'Posted On', labelKey: 'postedOn', clause: [{creationTime: {order: 'desc'}}]},
        {name: 'Apply By', labelKey: 'applyBy', clause: [{applyBy: {order: 'asc'}}]},
        {name: 'Applicants', labelKey: 'applicants', clause: [{applicantCount: {order: 'desc'}}]},
        {name: 'Views', clause: [{viewCount: {order: 'desc'}}]},
        {name: 'Salary', clause: [{minSalary: {order: 'asc'}}]}
        ],
        selectedSortName: 'Title',
        searchTerms: '',
        avatarColors: ['#e08a4a', '#3d5a99', '#9b8ac4', '#4a7c8c']
      }
    },

    computed: {
      ...mapState({
        'results': state => state.search.results,
        'total': state => state.search.total,
        'from': state => state.search.from,
        'pageNumber': state => state.search.pageNumber,
        'size': state => state.search.size,
        'facetResults': state => state.search.aggregations,
        'isResetSelectedItems': state => state.search.isResetSelectedItems,
        'libraryPositionMapping': state => state.search.libraryPositionMapping,
        'permission': state => state.user.permission,
        'institution' : state => state.institution.institution,
        'selectedFacets': state => state.search.selectedFacets
      }),
      numberOfSelectedItems () {
        return this.selectedUuids.length
      },
      isStudentLogin () {
        return (localStorage.getItem('userrole') === 'Student')
      },
      selectedSort () {
        let selected = this.sorts.find((sort) => {
          return sort.name === this.selectedSortName
        })
        return selected ? selected.clause : this.sorts[1].clause
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.query._) {
          this.populateUserLibrary()
        }
      },
      facetResults () {
        this.processFacetResult(this.facetResults.jobType, 'jobType')
      },
      foldersSelected () {
        if (this.ignoreFolderWatch) {
          this.ignoreFolderWatch = false
        } else {
          this.updateFacet()
        }
      },
      jobTypeSelected () {
        if (this.ignoreJobWatch) {
          this.ignoreJobWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'jobTypeSelected', value: this.jobTypeSelected})
        }
      },
      salaryRangeSelected () {
        if (this.ignoreSalaryWatch) {
          this.ignoreSalaryWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'salaryRangeSelected', value: this.salaryRangeSelected})
        }
      },
      tagSelected () {
        if (this.ignoreTagWatch) {
          this.ignoreTagWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'tagSelected', value: this.tagSelected})
        }
      },
      isResetSelectedItems () {
        if (this.isResetSelectedItems) {
          this.selectedUuids = []
          this.selectedObjects = []
          this.updateResetSelectedItems(false)
        }
      }
    },
    mounted () {
      this.showLoader()
      this.updatePageNumber(1)
      this.updateFrom(0)
      this.loadPermission().then(res => {
        this.loadLibraryPositionMapping()
        this.populateUserLibrary()
      })
    },
    methods: {
      ...mapActions([
        'loadUserInfo',
        'loadAllLibraryForUser',
        'constructSearchQuery',
        'deleteSelectedJobs',
        'updateFrom',
        'updatePageNumber',
        'updateSize',
        'updateResetSelectedItems',
        'loadLibraryPositionMapping',
        'loadPermission',
        'loadLogDashboardActivity',
        'storeSelectedFactes'
      ]),
      toggleJobDropDown () {
        this.showJobTypeDropDown = !this.showJobTypeDropDown
      },
      toggleSalaryRangeDropDown () {
        this.showSalaryRangeDropDown = !this.showSalaryRangeDropDown
      },
      searchButtonClicked () {
        this.updatePageNumber(1)
        this.updateFrom(0)
        this.constructQuery()
      },
      toggleSortByDropDown () {
        this.showSortByDropDown = !this.showSortByDropDown
      },
      sortOkClicked () {
        this.showSortByDropDown = false
        this.constructQuery()
      },
      millisToDate (millis) {
        if (!millis) {
          return this.$t('untilFilled')
        }
        return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
      },
      formatJobTypeLabel (value) {
        if (!value) {
          return value
        }
        let text = String(value).replace(/[_-]+/g, ' ')
        text = text.replace(/([a-z])([A-Z])/g, '$1 $2')
        text = text.replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
        let compact = text.replace(/\s+/g, '').toLowerCase()
        let known = {
          fulltime: 'Full Time',
          parttime: 'Part Time'
        }
        if (known[compact]) {
          return known[compact]
        }
        return text.replace(/\s+/g, ' ').trim()
      },
      jobTypeLabel (result) {
        if (result && result.jobTypes && result.jobTypes.length > 0) {
          return result.jobTypes[0]
        }
        return this.$t('na')
      },
      employerLogo (result) {
        if (!result) {
          return ''
        }
        return result.thumbnail || result.thumbnailURI || ''
      },
      employerInitials (title) {
        if (!title) {
          return ''
        }
        let first = title.trim().split(/\s+/)[0]
        if (first.length <= 4) {
          return first.toUpperCase()
        }
        return first.substring(0, 3).toUpperCase()
      },
      avatarColor (index) {
        return this.avatarColors[index % this.avatarColors.length]
      },
      jobLocation (result) {
        if (result && result.contactInfo && result.contactInfo.addresses && result.contactInfo.addresses.length > 0) {
          let address = result.contactInfo.addresses[0]
          let city = address.city || ''
          let state = address.state || ''
          if (city && state) {
            return city + ', ' + state
          }
          return city || state || this.$t('na')
        }
        return this.$t('na')
      },
      applicantCountMessage (result){
          let count = result.applicantCount || 0
          return (count<2)? ''+ count +' applicant':''+ count +' applicants'
      },
      plainDescription (result) {
        if (!result || !result.description) {
          return ''
        }
        let tmp = document.createElement('div')
        tmp.innerHTML = result.description
        return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim()
      },
      populateUserLibrary () {
        this.showLoader()
        this.userId = localStorage.getItem('userid')
        this.setupUserLibraries()
      },
      sortLibrariesIntoStandardOrder (libraries) {
        var sortedLibraryList = []
        for (var attr in this.libraryPositionMapping) {
          var value = this.libraryPositionMapping[attr]
          for (var i = 0; i < libraries.length; i++) {
            var library = libraries[i]
            if (this.libraryMatches(library, value)) {
              sortedLibraryList.push(library)
            }
          }
        }
        return sortedLibraryList
      },
      libraryMatches (library, value) {
        if (!library || !library.category) {
          return false
        }
        if (library.category === 'LearningSpace') {
          if (library.title === 'Shared With Me') {
            if (value === 'Shared') {
              return true
            }
          } else {
            if (value === 'Global') {
              return true
            }
          }
        }
        return library.category.indexOf(value) !== -1
      },
      updateFacet () {
        this.showLoader()
        this.updatePageNumber(1)
        this.updateFrom(0)
        this.constructQuery()
      },
      setupUserLibraries () {
        this.loadUserInfo().then(res => {
          let userPreferences = res.userPreferences || {}
          let selectedLearningSpaces = userPreferences.learningSpaces || []
          this.loadAllLibraryForUser().then(libraries => {
            this.folders = []
            this.allFolders = []
            this.foldersSelected = []
            this.publicLibraryList = []
            this.privateLibraryList = []
            this.ignoreFolderWatch = true
            let learningSpaces = this.sortLibrariesIntoStandardOrder(libraries)
            if (learningSpaces && learningSpaces.length > 0) {
              for (var i = 0; i < learningSpaces.length; i++) {
                let learningSpace = learningSpaces[i]
                const category = learningSpace.category
                if (category === 'LearningSpace' || category === 'Institute_Public' || category === 'User_Private') {
                  this.folders.push({value: learningSpace.uuid, text: learningSpace.displayName + '[0]'})
                  this.ignoreFolderWatch = true
                  this.allFolders.push(learningSpace.uuid)
                  if (selectedLearningSpaces.includes(learningSpace.uuid)) {
                    this.foldersSelected.push(learningSpace.uuid)
                  }
                  if (category !== 'Institute' && category !== 'User_Private') {
                    this.publicLibraryList.push(learningSpace.uuid)
                  }
                  if (category === 'User_Private') {
                    this.privateLibraryList.push(learningSpace.uuid)
                  }
                }
              }
              this.$nextTick(() => {
                this.$nextTick(() => {
                  this.populateSelectedFacetsFromState()
                })
              })
            }
            this.constructQuery()
          })
        })
      },
      showLoader (message) {
        if (this.$refs.loadingModal) {
          this.loadingMessage = message
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.loadingMessage = null
          this.$refs.loadingModal.hide()
        }
      },
      redirectToResult (result) {
        if (result.resourceType === 'job') {
          return this.$router.push({name: 'jobHome', params: { uuid: result.uuid }})
        }
      },
      createJobClicked () {
        return this.$router.push({ name: 'jobCreate' })
      },
      redirectToApplicants (result) {
        if (result.resourceType === 'job') {
          return this.$router.push({name: 'jobApplicants', params: { uuid: result.uuid }})
        }
      },
      redirectToViewers (result) {
        if (result.resourceType === 'job') {
          return this.$router.push({name: 'jobViewers', params: { uuid: result.uuid }})
        }
      },
      showEmployer (result){
          return this.$router.push({ name: 'employerDetails', params: { uuid: result.employerUuid } })

      },
      changeSize (option) {
        this.updateSize(option)
        this.updateFrom(0)
        this.updatePageNumber(1)
        this.constructQuery()
      },
      showTagsPopup (result) {
        this.popupTags = this.jobTags(result)
        if (this.$refs.tagsListPopup) {
          this.$refs.tagsListPopup.show()
        }
      },
      onPopupTagClick (tag) {
        this.filterJobsByTag(tag)
        this.closeTagsPopup()
      },
      jobTags (result) {
        let tags = []
        if (!result) {
          return tags
        }
        let appliedTagMap = result.appliedTagMap
        if (appliedTagMap) {
          Object.keys(appliedTagMap).forEach((key) => {
            let values = appliedTagMap[key]
            if (values && values.length) {
              for (let i = 0; i < values.length; i++) {
                let tag = values[i]
                tags.push({
                  key: 'applied-' + (tag.uuid || tag.name || i),
                  name: tag.name,
                  category: key,
                  kind: 'applied',
                  nameClass: 'instructional_tag',
                  cssClass: '',
                  level: ''
                })
              }
            }
          })
        }
        let competencies = result.careerCompetenciesList
        if (competencies && competencies.length) {
          for (let i = 0; i < competencies.length; i++) {
            let tag = competencies[i]
            let level = ''
            if (tag.fulfillLevels && tag.fulfillLevels.length > 0) {
              level = tag.fulfillLevels[0]
            }
            tags.push({
              key: 'competency-' + (tag.uuid || tag.name || i),
              name: tag.name,
              category: tag.tagType || '',
              kind: 'competency',
              nameClass: 'competency_tag',
              cssClass: tag.tagType || '',
              level: level
            })
          }
        }
        return tags
      },
      visibleJobTags (result) {
        return this.jobTags(result).slice(0, 2)
      },
      hasMoreJobTags (result) {
        return this.jobTags(result).length > 2
      },
      closeTagsPopup () {
        this.$refs.tagsListPopup.hide()
      },
      canApplyTag (ownerId, entity) {
        return EntityUtil.canEdit(ownerId, entity)
      },
      showAddTagPopup (result, event) {
        this.isShowTagPopup = true
        let appliedTagMap = result.appliedTagMap || {}
        let careerCompetenciesMap = result.careerCompetenciesMap || {}
        let careerCompetenciesList = result.careerCompetenciesList || []
        this.taggingEntityData = {uuid: result.uuid, title: result.title, type: 'job', appliedTagMap: appliedTagMap, careerCompetenciesMap: careerCompetenciesMap, careerCompetenciesList: careerCompetenciesList, isRefresh: true}
        setTimeout(() => {
          this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
        }, 500)
      },
      actionForSelectAllObjects () {
        this.selectedUuids = []
        this.selectedObjects = []
        if (!this.selectAllObjects) {
          this.results.forEach((item) => {
            this.selectedObjects.push(item)
            this.selectedUuids.push(item.uuid)
          })
        }
      },
      itemCheckboxToggle (ev, item) {
        if (ev.target.checked) {
          this.selectedObjects.push(item)
          if (this.selectedUuids.length === this.size) {
            this.selectAllObjects = true
          }
        } else {
          this.selectAllObjects = false
          const index = this.selectedObjects.findIndex((obj) => {
            return obj.uuid === item.uuid
          })
          if (index !== -1) {
            this.selectedObjects.splice(index, 1)
          }
        }
      },
      clearSelection () {
        this.selectedUuids = []
        this.selectedObjects = []
        this.selectAllObjects = false
      },
      showDeleteConfirmBox () {
        if (this.selectedUuids.length > 0) {
          this.$refs.deleteConfirmModal.show()
        }
      },
      tryDeleteWithNotify (deleteFunction, objectsToDelete, objectType) {
        if (!deleteFunction || !objectsToDelete || !objectsToDelete.length || objectsToDelete.length <= 0 || !objectType) {
          return
        }

        let uuids = []
        let loggedActionName = 'delete' + objectType
        let loadLogDashboardActivity = this.loadLogDashboardActivity
        objectsToDelete.forEach((obj) => {
          uuids.push(obj.uuid)
          loadLogDashboardActivity({action: loggedActionName, page: 'Manage Jobs', link: '', entityUuid: obj.uuid})
        })

        deleteFunction(uuids).then(res => {
          this.closeAndResetSelection()
          if (res) {
            if (res.succeeded > 0) {
              let message = '' + res.succeeded + ' ' + objectType + ' (s) deleted successfully.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: message
                })
              }, 0)
            }
            if (res.unauthorized > 0) {
              let message = '' + res.unauthorized + ' ' + objectType + ' not deleted due to lack of permission.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'warn',
                  title: '',
                  text: message
                })
              }, 500)
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: objectType + ' deletion failed due to a network issue.'
            })
          }
          setTimeout(() => {
            this.constructQuery()
          }, 1000)
        })
      },
      deleteItems () {
        this.showLoader()
        this.tryDeleteWithNotify(this.deleteSelectedJobs, this.selectedObjects, 'Job')
      },
      cancelDelete () {
        this.closeAndResetSelection()
      },
      closeAndResetSelection () {
        this.clearSelection()
        this.$refs.deleteConfirmModal.hide()
      },
      prevPage () {
        if (this.pageNumber >= 1 && (this.from - this.size) >= 0) {
          this.updatePageNumber(this.pageNumber - 1)
          this.updateFrom(this.from - this.size)
          this.constructQuery()
        }
      },
      nextPage () {
        if ((this.from + this.size) < this.total) {
          this.updatePageNumber(this.pageNumber + 1)
          this.updateFrom(this.from + this.size)
          this.constructQuery()
        }
      },
      resetLocalFields () {
        this.libraryList = ''
        this.selectedUuids = []
        this.selectedObjects = []
        this.selectAllObjects = false
      },
      buildFacet (field, size, order) {
        return {
          'aggs': {
            'termObj': {
              'terms': {
                'field': field,
                'size': size,
                'order': order
              }
            }
          },
          'filter': this.getFacetFilter()
        }
      },
      processFacetResult (facetResult, facetListName) {
        if (!facetResult) {
          return
        }
        this[facetListName] = []
        let terms = facetResult.termObj.buckets
        for (var i = 0; i < terms.length; i++) {
          let label = facetListName === 'jobType' ? this.formatJobTypeLabel(terms[i].key) : terms[i].key
          let term = {
            'text': label + ' [' + terms[i].doc_count + ']',
            'value': terms[i].key
          }
          this[facetListName].push(term)
        }
      },
      async constructQuery () {
        this.resetLocalFields()
        this.libraryList = this.allFolders.join(',')
        this.indexList = 'job'

        this.facets = {
          'jobType': this.buildFacet('jobTypes.raw', 100, {'_key': 'asc'})
        }

        this.filter = this.generateFilter()
        await this.constructSearchQuery({ terms: this.searchTerms, sort: this.selectedSort, preserveSort: true, source: this.source, from: this.from, size: this.size, indexList: this.indexList, libraryList: this.libraryList, privateLibraryList: this.privateLibraryList, publicLibraryList: this.publicLibraryList, userId: this.userId, aggs: this.facets, filter: this.filter })
        this.hideLoader()
      },
      generateFilter () {
        var filterObj = {
          'bool': this.originUuidCheck()
        }

        if (this.foldersSelected.length > 0) {
          let orQuery = {
            'bool': {
              'should': [
                getSimpleLibraryFilter(this.foldersSelected)
              ]
            }
          }
          filterObj.bool.must.push(orQuery)
        } else {
          let selected = []
          this.folders.forEach((folder) => {
            selected.push(folder.value)
          })
          let orQuery = {
            'bool': {
              'should': [
                getSimpleLibraryFilter(selected)
              ]
            }
          }
          filterObj.bool.must.push(orQuery)
        }

        filterObj.bool.must.push({
          'terms': {
            '_type': ['Job']
          }
        })

        if (this.jobTypeSelected.length > 0) {
          filterObj.bool.must.push({
            'terms': {
              'jobTypes.raw': this.jobTypeSelected
            }
          })
        }
        if (this.salaryRangeSelected.length > 0) {
          let salaryQueries = this.selectedSalaryRangeQueries()
          if (salaryQueries.length === 1) {
            filterObj.bool.must.push(salaryQueries[0])
          } else if (salaryQueries.length > 1) {
            filterObj.bool.must.push({
              'bool': {
                'should': salaryQueries,
                'minimum_should_match': 1
              }
            })
          }
        }
        if (this.tagSelected.length > 0) {
          filterObj.bool.must.push(this.buildTagFilter())
        }
        return filterObj
      },
      getFacetFilter () {
        return {
          'bool': this.originUuidCheck()
        }
      },
      originUuidCheck () {
        var originUuidCheck = {
          'must': [],
          'must_not': {
            'exists': {
              'field': 'originUuid'
            }
          }
        }
        return originUuidCheck
      },
      populateSelectedFacetsFromState () {
        this.ignoreJobWatch = true
        this.jobTypeSelected = this.selectedFacets.jobTypeSelected || []
        this.ignoreSalaryWatch = true
        this.salaryRangeSelected = this.selectedFacets.salaryRangeSelected || []
        this.ignoreTagWatch = true
        this.tagSelected = this.selectedFacets.tagSelected || []
      },
      removeSelectedFacet (key, index) {
        if (key === 'jobTypeSelected') {
          this.jobTypeSelected.splice(index, 1)
        } else if (key === 'salaryRangeSelected') {
          this.salaryRangeSelected.splice(index, 1)
        } else if (key === 'tagSelected') {
          this.tagSelected.splice(index, 1)
        }
      },
      filterJobsByTag (tag) {
        let selected = this.normalizeTagSelection(tag)
        if (!selected.name) {
          return
        }
        let exists = this.tagSelected.some((item) => {
          return this.tagSelectionName(item) === selected.name
        })
        if (!exists) {
          this.tagSelected.push(selected)
        }
      },
      normalizeTagSelection (tag) {
        if (!tag) {
          return { name: '', category: '' }
        }
        if (typeof tag === 'string') {
          return { name: tag, category: '' }
        }
        return {
          name: tag.name || '',
          category: tag.category || ''
        }
      },
      tagSelectionName (tag) {
        if (!tag) {
          return ''
        }
        return tag.name || tag
      },
      buildTagFilter () {
        let must = []
        this.tagSelected.forEach((tag) => {
          let selected = this.normalizeTagSelection(tag)
          if (!selected.name) {
            return
          }
          let should = []
          if (selected.category) {
            let terms = {}
            terms['appliedTagMap.' + selected.category + '.name'] = [selected.name]
            should.push({
              'terms': terms
            })
          }
          should.push({
            'query_string': {
              'query': '"' + String(selected.name).replace(/"/g, '') + '"',
              'fields': ['appliedTagMap.*.name']
            }
          })
          should.push({
            'terms': {
              'careerCompetenciesList.name': [selected.name]
            }
          })
          should.push({
            'terms': {
              'careerCompetenciesList.name.keyword': [selected.name]
            }
          })
          must.push({
            'bool': {
              'should': should,
              'minimum_should_match': 1
            }
          })
        })
        return {
          'bool': {
            'must': must
          }
        }
      },
      salaryRangeQuery (group) {
        let must = []
        if (group.minLt !== undefined) {
          must.push({
            'range': {
              'minSalary': { 'lt': group.minLt }
            }
          })
        }
        if (group.minGt !== undefined) {
          must.push({
            'range': {
              'minSalary': { 'gt': group.minGt }
            }
          })
        }
        if (group.maxLt !== undefined) {
          must.push({
            'range': {
              'maxSalary': { 'lt': group.maxLt }
            }
          })
        }
        if (must.length === 1) {
          return must[0]
        }
        return {
          'bool': {
            'must': must
          }
        }
      },
      selectedSalaryRangeQueries () {
        let queries = []
        for (let i = 0; i < this.salaryRangeGroups.length; i++) {
          let group = this.salaryRangeGroups[i]
          if (this.salaryRangeSelected.indexOf(group.label) !== -1) {
            queries.push(this.salaryRangeQuery(group))
          }
        }
        return queries
      }
    }
  }
</script>

<style scoped>
	.collapsed > .collapsed,
	:not(.collapsed) > .expand {
	  display: none;
	}

  .description_row {
    height: auto;
    min-height: 24px;
    margin-top: 10px;
    margin-bottom: 0;
  }

  .datatable .result_block {
    margin-top: 5px;
  }

  .job-header-row {
    align-items: center;
    margin-bottom: 15px;
  }

  .job-employer {
    display: flex;
    align-items: center;
    margin-left: 36px;
    min-width: 0;
  }

  .job-employer .employer-avatar {
    width: 80px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    color: #000;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.2px;
    overflow: hidden;
    flex-shrink: 0;
  }

  .job-employer .employer-avatar.has-logo {
    background: transparent;
  }

  .job-employer .employer-avatar img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }


  .datatable .result_block .title {
    font-weight: 400;
    float: none;
    margin-bottom: 0;
  }






  .job-tags-item,
  .job-description-item {
    flex: 1;
    min-width: 0;
    margin-right: 0;
  }

  .datatable .result_block .job-tags-item .details {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    float: none;
    width: auto;
    max-width: none;
    height: auto;
    overflow: hidden;
  }

  .datatable .result_block .job-tags-item .tags_container,
  .datatable .result_block .job-tags-item .tags_cat {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    float: none;
    width: auto;
    max-width: none;
    height: auto;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .datatable .result_block .job-tags-item .tags_container {
    flex: 0 1 auto;
    min-width: 0;
  }

  .datatable .result_block .job-tags-item .job-all-tags {
    display: none;
  }

  .datatable .result_block .job-tags-item .no_tags {
    float: none;
    margin-top: 0;
    margin-bottom: 0;
  }

  .datatable .result_block .job-tags-item .no_tags .empty_pattern {
    padding: 0;
  }

  .datatable .result_block .job-tags-item .tag {
    flex-shrink: 0;
    white-space: nowrap;
    margin: 0 8px 0 0;
    height: 26px;
    align-items: center;
    cursor: pointer;
  }

  .datatable .result_block .job-tags-item .tag .tag_name {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    line-height: 22px;
  }

  .datatable .result_block .job-tags-item .btn.ic24-pencil {
    float: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    height: 26px;
    width: 26px;
    min-height: 26px;
    min-width: 26px;
    padding: 0;
    margin: 0 0 0 4px;
    line-height: 26px;
    font-size: 16px;
  }

  .datatable .result_block .job-tags-item .btn_ellipsis,
  .datatable .result_block .job-tags-item .icon-edit,
  .datatable .result_block .job-tags-item .ic-edit {
    float: none;
    margin-top: 0;
    margin-left: 4px;
    flex-shrink: 0;
    height: 26px;
    min-height: 26px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .job-description-item .title_new,
  .job-description-item .no-description {
    float: none;
    width: auto;
    flex: 1;
    min-width: 0;
  }

  .datatable .result_row .thumbnail {
    display: none;
  }

  .datatable .result_row {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .datatable {
    width: 100%;
    margin-left: 0;
    margin-top: 0;
  }

  .explore_entity_result {
    margin-left: 0;
    margin-right: 0;
  }

  .search_result_container {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }

  .result_block {
    width: calc(100% - 40px);
  }

  .job-board-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 5px 27px;
    border-bottom: 1px solid #ebebeb;
    background: #fff;
    flex-wrap: nowrap;
  }

  .toolbar-left,
  .toolbar-right {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }
  .toolbar-right .out-of-total-item {
    margin-right: 10px;
  }
  .toolbar-left .explore_filter {
    position: relative;
    float: none;
    display: flex;
    align-items: center;
  }

  .toolbar-left .explore_filter .dropdown_popover {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 0;
  }

  .toolbar-select-all {
    margin-right: 10px;
  }

  .toolbar-select-all input[type="checkbox"] {
    width: 17px;
    height: 17px;
    margin: 0;
  }



  .toolbar-left .form-field {
    padding: 0 10px;
    display: flex;
    align-items: center;
    margin-right: 8px;
    border-radius: 4px;
    border: none;
    color: #000 !important;
  }

  .toolbar-left .form-field:hover,
  .toolbar-left .form-field:focus,
  .toolbar-left .form-field:active {
    color: #000 !important;
  }

  .toolbar-left .form-field label,
  .toolbar-left .form-field .txt_sh,
  .toolbar-left .form-field  {
    margin: 0;
    color: #000 !important;
  }
  .toolbar-left .form-field label {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .toolbar-left .job-type-filter,
  .toolbar-left .job-type-filter:hover,
  .toolbar-left .job-type-filter:focus {
    background: #7ad8f0 !important;
    color: #000 !important;
  }

  .toolbar-left .salary-filter,
  .toolbar-left .salary-filter:hover,
  .toolbar-left .salary-filter:focus {
    background: #c8e6c0 !important;
    color: #000 !important;
  }

  .toolbar-right .pagination {
    display: flex;
    align-items: center;
    margin-right: 12px;
    margin-top: 0;
    padding-top: 0;
  }


  .toolbar-right .search-box-container {
    display: flex;
    align-items: center;
    width: auto;
    float: none;
  }

  .toolbar-right .ic_bin {
    cursor: pointer;
    margin-right: -15px;
    font-size: 28px;
  }

  .toolbar-right .ic_bin.disable {
    color: rgba(0, 0, 0, 0.3);
    cursor: default;
  }

  .job-board-filter-tags .filter-tag .job-type-tag {
    background-color: #ffb0c4;
  }

  .job-board-filter-tags .filter-tag .salary-tag {
    background-color: #c8e6c0;
  }

  .job-board-filter-tags .filter-tag .job-applied-tag {
    background-color: #f6e59b;
  }

</style>

<style>
  /* Popover is injected by bootstrap-vue, so these cannot be scoped. */
  .job-board-page .explore_filter_container .popover {
    transform: none !important;
    top: 42px !important;
    left: 0px !important;
    margin: 0px !important;
    min-width: 440px;
  }

  .job-count-link {
      cursor: pointer;
      text-decoration: none;
  }
  .job-count-link:hover {
      /*text-decoration: underline;*/
  }

</style>



// WEBPACK FOOTER //
// src/app/search/components/ManageJobs.vue